import React from "react";
import Typography from "@material-ui/core/Typography";
const CRMReports = ({}) => {
  return (
    <React.Fragment>
      <Typography paragraph variant="h4">
        CRM Reports
      </Typography>
      <Typography paragraph variant="h5">
        Explore dashboard and various reports of CRM module
      </Typography>
      <Typography paragraph variant="body1">
        CRM Reports is one of the features under the CRM module to display
        various reports regarding the CRM business process. It is used to
        analyze information, determine conclusions, and offer recommendations to
        solve problems.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        How it works
      </Typography>
      <Typography paragraph variant="body1">
        The first information displayed on this feature is the tabs indicating
        the various report types. The various reports under the CRM module are
        listed below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>CRM Dashboard</b>
        <br />
        This is the main dashboard of the CRM module. There is a lot of
        high-level information shown as a widget to give you the best insight
        regarding what happens in the CRM business process. This best analytic
        information will help you a lot to make business decisions. Below are
        the available widgets inside this dashboard:
        <ul>
          <li>Leads Widget</li>
          <li>Opportunity Ratio Widget</li>
          <li>Deals In Pipeline Widget</li>
          <li>Win Rate Widget</li>
          <li>Opportunity Value Overview Widget</li>
          <li>Opportunity Overview Widget</li>
          <li>Open Opportunities Widget</li>
          <li>Open Opportunities Value Widget</li>
          <li>Average Deals Won Value Widget</li>
          <li>Average Sales Life Cycle Widget</li>
          <li>Top 5 Sources Widget</li>
          <li>Top 5 Deals Widget</li>
          <li>Top 5 Industries Widget</li>
          <li>Top 5 Businesses Widget</li>
          <li>Top 5 Countries Widget</li>
          <li>Top 5 Priorities Widget</li>
          <li>Sales Pipeline Stage Widget</li>
          <li>Deals Stage Widget</li>
        </ul>
      </Typography>
      <Typography paragraph variant="body1">
        <b>Sales Pipeline</b>
        <br />
        This report tells you about every won & lost deal value, average & total
        deal value, and open opportunities on each sales pipeline.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Sales Performance</b>
        <br />
        This report tells you about every performance of each salesman and their
        average deal value.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Sales Card</b>
        <br />
        This report tells you about every sales card position status and their
        estimation value.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Visit Schedule</b>
        <br />
        This report tells you about every sales journey visit status and their
        planning date estimation to visit the potential customers.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Direct Sales</b>
        <br />
        This report tells you about every direct sales log and its sales
        document during on-the-spot sales by the salesman team.
      </Typography>
    </React.Fragment>
  );
};

export default CRMReports;
